<template>
    <div
        class="search-form"
        :class="{
            'search-form--full': searchResultProducts.length > 0 || searchResultPages.length > 0,
            is_static: is_static,
        }">
        <div :class="{ container: !is_static }">
            <div class="form-group">
                <input
                    type="text"
                    class="form-group__input form-group__input--search text_19"
                    :placeholder="$t('what_search')"
                    @input="searchRequest(searchQuery)"
                    v-model="searchQuery" />
            </div>
            <div class="search-form__subheader text_11">
                <div class="search-form__close like-link" v-if="!is_static" @click="$parent.isShowSearch = false">
                    {{ $t("close") }}
                </div>
                <transition name="fade" mode="out-in">
                    <div class="search-form__hint" v-if="isSearchLoading" :key="5">
                        <span class="color-text_3">{{ $t("loading") }}</span>
                    </div>
                    <div class="search-form__hint" v-else-if="searchQuery.length < 3" :key="1">
                        <span class="color-text_3">{{ $t("exmpl") }}</span>
                        <nuxt-link
                            class="search-form__suggest search-form__suggest--categories like-link"
                            v-for="(category, index) in suggestCategories"
                            @click="searchQuery = category.name"
                            :to="`/rezultaty-poiska?q=${category.name}`"
                            :key="index"
                            >{{ category.name }}</nuxt-link
                        >
                    </div>
                    <div class="search-form__hint" v-else :key="2">
                        <span
                            class="color-text_3"
                            v-if="searchResultProducts.length > 0 || searchResultPages.length > 0"
                            :key="3"
                            >{{ $t("found") }} {{ searchResultProducts.length + searchResultPages.length }}</span
                        >
                        <span class="color-text_3" v-else :key="4">{{ $t("nothinf_found") }}</span>
                        <span class="search-form__delimeter">/</span>
                        <span
                            class="search-form__suggest like-link"
                            @click="
                                searchQuery = '';
                                searchResultProducts = [];
                                searchResultPages = [];
                            "
                            >{{ $t("filter_clear") }}</span
                        >
                        <span
                            class="search-form__suggest-blk"
                            v-if="searchResultProducts.length == 0 || searchResultPages.length == 0">
                            <span class="color-text_3">{{ $t("try") }}</span>
                            <nuxt-link
                                class="search-form__suggest search-form__suggest--categories like-link"
                                v-for="(category, index) in suggestCategories"
                                :to="`/rezultaty-poiska?q=${category.name}`"
                                :key="index"
                                >{{ category.name }}</nuxt-link
                            >
                        </span>
                    </div>
                </transition>
            </div>
            <div class="search-form__results container-ignore" v-bsl="$parent.isShowSearch">
                <transition name="fade" mode="out-in">
                    <div
                        class="search-form__results-wrapper"
                        v-if="!isSearchLoading && (searchResultProducts.length > 0 || searchResultPages.length > 0)"
                        :key="2">
                        <div class="row flex-row row--fullwidth" v-if="searchResultPages.length > 0">
                            <div
                                class="col lg-4 sm-6 col--no-padding"
                                v-for="(page, id) in searchResultPages"
                                :key="id">
                                <nuxt-link :to="page.path" class="link">
                                    {{ page.text }}
                                </nuxt-link>
                            </div>
                        </div>
                        <div class="row flex-row row--fullwidth" v-if="searchResultProducts.length > 0">
                            <div
                                class="col lg-3 sm-6 col--no-padding"
                                v-for="(product, id, index) in searchResultProducts"
                                :key="product.id">
                                <Product :data="product" :index="index + 1" />
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="
                            !isSearchLoading &&
                            (searchResultProducts.length == 0 || searchResultPages.length == 0) &&
                            searchQuery.legnth >= 3
                        "
                        :key="3">
                        {{ $t("nothinf_found") }}
                    </div>
                </transition>
            </div>
        </div>
        <div class="search-form__dimmer" @click="$parent.isShowSearch = false"></div>
    </div>
</template>
<script>
import Product from "~/components/Product";

export default {
    name: "Search",
    components: { Product },
    props: {
        is_static: {
            type: Boolean,
            default: false,
        },
        query: {
            type: String,
        },
        lang: {
            type: String,
        },
    },
    data() {
        return {
            searchQuery: "",
            searchResultProducts: [],
            searchResultPages: [],
            isSearchLoading: false,
            timer: null,
            suggestCategories: [],
            count: this.$device.isDesktop ? 5 : 3,
        };
    },
    watch: {
        // searchQuery(q) {
        //     this.searchRequest(q);
        // },
        query(q) {
            this.searchQuery = q;
            this.searchRequest(q);
        },
        $route() {
            this.$parent.isShowSearch = false;
        },
        searchResultProducts(val) {
            this.isSearchLoading = false;
            this.$grom.pushGTMshowProducts(val);
        },
        lang() {
            this.get();
        },
    },
    methods: {
        get() {
            this.$axios
                .get("/api/categories", {
                    params: {
                        random: this.count,
                    },
                })
                .then((res) => {
                    this.suggestCategories = res.data;
                });
        },
        searchRequest(q) {
            if (this.is_static) {
                this.isSearchLoading = true;
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                if (q.length >= 3) {
                    this.timer = setTimeout(() => {
                        this.$axios
                            .get("/api/search", {
                                params: {
                                    query: q,
                                },
                            })
                            .then((res) => {
                                this.searchResultProducts = [
                                    ...new Map(
                                        this.$grom.removeSoldItems(res.data.products).map((item) => [item.id, item])
                                    ).values(),
                                ];
                                this.searchResultPages = res.data.pages;
                                window.history.replaceState(null, null, this.$utm.url("?q=" + q));
                                // this.products_to_vk = [];
                                // this.searchResultProducts.forEach((element) => {
                                //     this.products_to_vk.push({
                                //         id: element.id,
                                //         price: element.price,
                                //     });
                                // });
                                // this.$fb.fbq("track", "Search");
                            });
                    }, 1000);
                } else {
                    this.searchResultProducts = [];
                    this.searchResultPages = [];
                }
            } else {
                this.$router.push("/rezultaty-poiska?q=" + q);
            }
        },
    },
    mounted() {
        this.get();
        if (this.query) {
            this.searchQuery = this.query;
            this.searchRequest(this.query);
        }
    },
};
</script>
<style lang="less">
.search-form {
    &.is_static {
        .form-group__input--search {
            height: auto;
            padding-bottom: 6px;
            margin-top: 7px;
        }
    }
    &:not(.is_static) {
        left: 0;
        right: 0;
        top: 100%;
        background: #fff;
        padding-top: 5px;
        position: absolute;
        @media @sm {
            border-top: 1px solid @border2;
            background: #fff;
            box-shadow: inset 0 69px @bg;
        }
        .search-form {
            &__dimmer {
                position: fixed;
                top: 106px;
                bottom: 0;
                left: 0;
                right: 0;
                z-index: 1;
                background: rgba(242, 241, 233, 0.7);
                @media @sm {
                    border-top: 1px solid @border2;
                }
            }
            &--full {
                top: 37px;
                position: fixed;
                bottom: 0;
                @media @sm {
                    top: 36px;
                    .search-form__dimmer {
                        background: none;
                    }
                }
            }
        }
    }
    .form-group {
        flex-shrink: 0;
        &__input {
            padding-left: 0;
            padding-right: 0;
            border-bottom: 1px solid #000;
            &--search {
                height: 25px;
                padding-bottom: 2px;
                margin-top: 5px;
            }
        }
    }
    &__subheader {
        padding: 11px 0 8px;
        position: relative;
        @media @sm {
            padding: 16px;
            background: @bg;
            margin: 0 -16px;
        }
    }
    &__suggest {
        margin-left: 10px;
        &-blk {
            margin-left: 33px;
            @media @sm {
                margin-left: 0;
                width: 100%;
                display: block;
                margin-top: 16px;
            }
        }
        @media @sm {
            &--categories {
                display: block;
                margin-left: 0;
                margin-top: 16px;
            }
        }
    }
    &__close {
        position: absolute;
        right: 0;
        top: 11px;
        z-index: 1;
        @media @sm {
            top: 16px;
            right: 16px;
        }
    }
    &__delimeter {
        margin-right: -4px;
        margin-left: 6px;
    }
    &__results {
        &-wrapper {
            display: flex;
            flex-direction: column;
            gap: 125px;
            > .row:nth-child(2) {
                border-top: 1px solid @border2;
            }
            @media @sm {
                gap: 70px;
            }
        }
        .link {
            color: inherit;
            position: relative;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            height: 120px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            transition: background 0.3s 0s ease;
            margin: 0 1px;
            border: 1px solid @border2;
        }
        @media @notsm {
            max-height: calc(100dvh - 107px);
            overflow-y: auto;
        }
        @media @sm {
            flex-grow: 1;
            overflow-y: auto;
        }
    }
    .container {
        height: 100%;
        display: flex;
        overflow: hidden;
        flex-direction: column;
        position: relative;
        z-index: 2;
    }
}
</style>
